import React from 'react';
import { Box, MenuItem, Select } from '@mui/material';
import { useAuthStore } from '../../store/storeAuth';
import Label from '../UI/Label/Label';
import { GoogleSlidesPresentation } from '../PullDataNode/PullDataNode';
import TagInput from '../Test/TagInput';

interface PullGoogleSlidesDataProps {
  formData: any;
  onChange: (e: any) => void;
  nodeLabel: string;
  data: any;
  presentations: GoogleSlidesPresentation[];
  nodeId: string;
}

const PullGoogleSlidesData: React.FC<PullGoogleSlidesDataProps> = ({
  formData,
  onChange,
  nodeLabel,
  data,
  presentations,
  nodeId,
}) => {
  const { user } = useAuthStore(state => state);

  return (
    <Box width={'360px'}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <Label
          labelStyle={{ marginTop: '10px' }}
          labelName="Settings"
          isAdvanced
        />

        <Box>
          <Label
            labelName="Select Presentation"
            isAdvanced
            labelStyle={{
              fontSize: '14px',
              color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
              fontWeight: 400,
            }}
          />

          <Select
            className="nodrag"
            name="presentationId"
            value={formData.presentationId}
            onChange={onChange}
            sx={{
              width: '60%',
              '& .MuiList-root': {
                backgroundColor: user?.theme === 'dark' ? '#101828' : '#F9FAFB',
              },
              '& .MuiSvgIcon-root': {
                color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
              },
              borderRadius: '8px',
              border: 'none',
              boxShadow: 'none',
              '.MuiOutlinedInput-notchedOutline': { border: 0 },
              bgcolor: user?.theme === 'dark' ? '#101828' : '#F9FAFB',
              color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  '& .Mui-selected': {
                    backgroundColor:
                      user?.theme === 'dark' ? '#667085' : '#D0D5DD',
                  },
                  backgroundColor:
                    user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
                },
              },
            }}
          >
            {presentations.map(presentation => (
              <MenuItem
                key={presentation.id}
                value={presentation.id}
                sx={{
                  color: user?.theme === 'dark' ? '#D0D5DD' : 'black',
                }}
              >
                {presentation.name}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <TagInput
          placeholder="Select slides [1, 2-5, 8]"
          onChange={onChange}
          nodeId={nodeId}
          name="slidesFilter"
          value={formData.slidesFilter}
          isAdvanced
          showCopy
          dataConnected={data?.slidesFilterData || []}
          removeIcons
          labelName={'Select Area (Optional)'}
          isCollapsed
          handleId="slidesFilter"
          nodeLabel={nodeLabel}
          labelStyle={{
            fontSize: '14px',
            color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
            fontWeight: 400,
          }}
          advancedCollapsed
        />
      </Box>
    </Box>
  );
};

export { PullGoogleSlidesData };
